export enum TRANS_MASTER_STATUS {
  CREATED = "CREATED",
  GENERATED = "GENERATED",
  APPROVED = "APPROVED",
  OUTREACHED = "OUTREACHED",
  IN_PROGRESS = "IN_PROGRESS",
  CLOSED = "CLOSED",
}

// Helper function to get all status values as an array (for backward compatibility)
export const TRANS_MASTER_STATUS_VALUES = Object.values(TRANS_MASTER_STATUS);

// Helper function to get status options for dropdowns
export const TRANS_MASTER_STATUS_OPTIONS = TRANS_MASTER_STATUS_VALUES.map((status) => ({
  value: status,
  label: status,
}));